import { render, staticRenderFns } from "./ThePaginator.vue?vue&type=template&id=22434c3c"
import script from "./ThePaginator.vue?vue&type=script&lang=ts"
export * from "./ThePaginator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheSelect: require('/usr/src/nuxt-app/components/core/select/TheSelect.vue').default})
